"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transfer = void 0;

var Transfer =
/** @class */
function () {
  function Transfer(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - transferId
   * @param string[]? - withData
   * @return Promise|Observable|any
   */


  Transfer.prototype.GetTransfer = function (transferId, withData) {
    if (withData === void 0) {
      withData = null;
    }

    return this.restClient.get('Transfer/UseCase/GetTransfer', {
      transferId: transferId,
      withData: withData
    });
  };
  /**
   * @param string - eventId
   * @param string[]? - withData
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @param string? - sortBy
   * @param string? - sortDirection
   * @return Promise|Observable|any
   */


  Transfer.prototype.ListTransfersForEvent = function (eventId, withData, page, itemsPerPage, sortBy, sortDirection) {
    if (withData === void 0) {
      withData = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    return this.restClient.get('Transfer/UseCase/ListTransfersForEvent', {
      eventId: eventId,
      withData: withData,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  };
  /**
   * @param string - invitationId
   * @param string[]? - withData
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-100
   * @param string? - sortBy
   * @param string? - sortDirection
   * @return Promise|Observable|any
   */


  Transfer.prototype.ListTransfersForInvitation = function (invitationId, withData, page, itemsPerPage, sortBy, sortDirection) {
    if (withData === void 0) {
      withData = null;
    }

    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    return this.restClient.get('Transfer/UseCase/ListTransfersForInvitation', {
      invitationId: invitationId,
      withData: withData,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }; // Commands

  /**
   * @param string - transferId
   * @param string - code
   * @param boolean? - shouldSendEmail true|false
   * @return Promise|Observable|any
   */


  Transfer.prototype.ConfirmTransfer = function (transferId, code, shouldSendEmail) {
    if (shouldSendEmail === void 0) {
      shouldSendEmail = null;
    }

    return this.restClient.post('Transfer/UseCase/ConfirmTransfer', {
      transferId: transferId,
      code: code,
      shouldSendEmail: shouldSendEmail
    });
  };
  /**
   * @param string - eventId
   * @param string - senderId
   * @param string - firstName
   * @param string - lastName
   * @param string - email
   * @param number - transferQty
   * @param boolean? - shouldSendEmail true|false
   * @param boolean? - forceTransfer true|false
   * @param string? - transferId
   * @return Promise|Observable|any
   */


  Transfer.prototype.CreateTransfer = function (eventId, senderId, firstName, lastName, email, transferQty, shouldSendEmail, forceTransfer, transferId) {
    if (shouldSendEmail === void 0) {
      shouldSendEmail = null;
    }

    if (forceTransfer === void 0) {
      forceTransfer = null;
    }

    if (transferId === void 0) {
      transferId = null;
    }

    return this.restClient.post('Transfer/UseCase/CreateTransfer', {
      eventId: eventId,
      senderId: senderId,
      firstName: firstName,
      lastName: lastName,
      email: email,
      transferQty: transferQty,
      shouldSendEmail: shouldSendEmail,
      forceTransfer: forceTransfer,
      transferId: transferId
    });
  };
  /**
   * @param string - transferId
   * @return Promise|Observable|any
   */


  Transfer.prototype.DeleteTransfer = function (transferId) {
    return this.restClient.post('Transfer/UseCase/DeleteTransfer', {
      transferId: transferId
    });
  };
  /**
   * @param string - transferId
   * @param boolean? - shouldSendEmail true|false
   * @return Promise|Observable|any
   */


  Transfer.prototype.ForceTransfer = function (transferId, shouldSendEmail) {
    if (shouldSendEmail === void 0) {
      shouldSendEmail = null;
    }

    return this.restClient.post('Transfer/UseCase/ForceTransfer', {
      transferId: transferId,
      shouldSendEmail: shouldSendEmail
    });
  };
  /**
   * @param string - transferId
   * @return Promise|Observable|any
   */


  Transfer.prototype.ResendAuthorizationRequestEmail = function (transferId) {
    return this.restClient.post('Transfer/UseCase/ResendAuthorizationRequestEmail', {
      transferId: transferId
    });
  };

  return Transfer;
}();

exports.Transfer = Transfer;